import emit from '../../common/events';

/**
 * Instructor sampling analytics class.
 * It reuses the original method names from the instructor sampling component to avoid confusion.
 */
export class InstructorSampleAnalytics {
  static emit(eventName: string, element?: HTMLElement): void {
    emit(this.buildEventPayload(eventName, element));
  }

  static emitElement(eventName: string, element?: HTMLElement): void {
    emit(this.buildEventPayload(eventName, element, true));
  }

  private static buildEventPayload(eventName: string, element?: HTMLElement, includeElement = false): any {
    return {
      ...(includeElement && element ? { element } : {}),
      name: eventName,
      detail: {
        ...(element ? { id: element.id } : {}),
      },
      dataLayer: true,
    };
  }
}
